export default __webpack_public_path__ + "static/media/fridge2-afterA-480w.ce8c3d86.webp";